import { useMutation } from '@tanstack/react-query';
import {
  ServiceFeeSuggestion,
  getPerOrderFeeSuggestion,
} from '@vgrubs/components';

/**
 * The AI suggestion for a location's per-order vTablet fee, worked out for
 * the monthly target passed to `mutate` (cents; 0 or undefined lets the
 * backend fall back to the saved fee, then $89).
 *
 * A mutation rather than a query on purpose: every click has to be a fresh
 * suggestion (nothing is cached on either side), and each call is several
 * seconds of paid AI work, so it must never fire on its own - not on a
 * remount, a window focus or a retry policy. `mutate()` is the only trigger.
 */
export const usePerOrderFeeSuggestion = (locationId: number | string) =>
  useMutation({
    mutationFn: async (
      target: number | undefined
    ): Promise<ServiceFeeSuggestion> => {
      const { data } = await getPerOrderFeeSuggestion(locationId, target);
      return data.data;
    },
  });
